'use strict';

import { view } from '@/functions';

export default [
    {
        path: '/ai-tools',
        name: 'ai-tools',
        meta: {
            title: 'AI tools & actions',
            scopes: ['read_ai_conversations'],
        },
        component: () => view('ai-tools/index'),
    },
];
